<po-loading-overlay
  class="po-page-content po-page"
  [ngClass]="loading$ | async"
  p-screen-lock="false"
  [p-text]="i18nService.getLiteralByKey('str0128')"
>
</po-loading-overlay>
